window.isProductAvailable=true;

function resetAvailable(component_,variant_) {
    console.log("reset available");
    var buttn=document.getElementById('checkAvailable');
    var buttnText=document.getElementById('checkAvailableText');
   	buttn.style='background-color:transparent';
    buttn.textContent="... beim Lieferanten verfügbar?";
    buttn.removeAttribute('title');
    buttnText.textContent="";	
    window.isProductAvailable=true;
}

function checkAvailable(sku,qty) {
  //const url=`https://europe-west6-cash36-prod-262508.cloudfunctions.net/available?sku=${sku}&qty=${qty}`
  const     url=`https://europe-west6-arzt-shopping.cloudfunctions.net/available?sku=${sku}&qty=${qty}`
 
  var ret=ajax(url,data => {
    console.log(JSON.stringify(data));
    
    var buttn=document.getElementById('checkAvailable');
    var buttnText=document.getElementById('checkAvailableText');
    
    
    //{"status":"NO","sku":"2944745","message":"Wird besorgt/gel. ab 28.06.22","value":"later"}
       
    window.isProductAvailable=false;
    if (data.status=='ERROR') {
      buttn.style.backgroundColor='#FFCCCB';
      buttn.textContent="Hinweis: Medikament oder Produkt ist beim Grosshändler Galexus nicht verfügbar, dh es könnte zu Lieferschwierigkeiten kommen. Sie können das Produkt trotzdem bestellen und bei Ihrem Arzt nachfragen.  Sie können auch prüfen, ob eine Generika Gruppe vorhanden ist (nach unten Scrollen). ";
      buttn.removeAttribute('title');
      //buttn.style.color='red';
      buttnText.textContent=data.error;
      
    } else if (data.status=='OK') {
      window.isProductAvailable=true;
      buttn.style.backgroundColor='lightgreen';
      var buttonText="OK ";
      if (data.value="yes") buttonText=" JA: verfügbar. "
      buttn.textContent=buttonText;
      if (data.message){
        buttn.setAttribute('title', "Daten vom Grosshändler: "+data.message+"; "+data.value);
        buttnText.textContent="";
      } else {
        buttn.removeAttribute('title');
        buttnText.textContent="";
      }
    } else if (data.status=='NO') {
      buttn.style.backgroundColor='#FFCCCB';
      buttn.textContent="NEIN: ";
      buttn.removeAttribute('title');
      if (data.message){
        buttnText.textContent=" Prüfen Sie ob eine Generika Gruppe vorhanden ist (nach unten Scrollen). Daten vom Grosshändler: "+data.message+"; "+data.value;
      }
      
    } else {
      buttnText.textContent=JSON.stringify(data);
    }
  });
}
  


function ajax(url /* ,params */, callback) {
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = function() {
      // return if not ready state 4
      if (this.readyState !== 4) {
        return;
      }

      // check for redirect
      if (this.status === 302 /* or may any other redirect? */) {
        var location = this.getResponseHeader("Location");
        return ajax.call(this, location /*params*/, callback);
      } 
    
      // return data
      var data = JSON.parse(this.responseText);
      callback(data);
  };
  xmlhttp.open("GET", url, true);
  xmlhttp.send();
}

function preventSubmitIfNotAvailable(cartForm) { //document.forms['{{ form_id }}']
    //var cartForm = document.querySelector('form[action="/cart/add"]'); // Adjust the selector to target your specific form
    if (cartForm) {
        cartForm.addEventListener('submit', function(event) {
            //console.log("lkdsfjlkfdsj "+window.isProductAvailable);
            if (window.isProductAvailable == false ) {
                event.preventDefault(); // Prevents the form from submitting
                // Optional: display a message to the user
                alert("Das Produkt ist derzeit nicht lieferbar und kann nicht bestellt werden.");
            }
        });
    }
}

function containsAnyWord(blockAddToBasket) {
  // Get the div with the specific class
  const productBlockHeader = document.querySelector('.product-block--header');

  // Check if the div exists
  if (productBlockHeader) {
    // Get the h1 tag within this div
    const h1Tag = productBlockHeader.querySelector('h1');

    // Check if the h1 tag exists
    if (h1Tag) {
      // Convert the innerHTML to lowercase
      const innerHtmlLowerCase = h1Tag.innerHTML.toLowerCase();

      // Check each word in the array
      for (let word of blockAddToBasket) {
        if (innerHtmlLowerCase.includes(word.toLowerCase())) {
          return true;
        }
      }
    }
  }

  // Return false if the div or h1 tag is not found, or none of the words are found
  return false;
}


function preventSubmitIfNoPrice(cartForm) { 
  //console.debug(".. wasa  preventSubmitIfNoPrice ");

  if (cartForm) {
    cartForm.addEventListener('submit', function(event) {
      // Spezifischen Selektor für das Preis-Element verwenden
      const priceElement = document.querySelector('[data-product-price]');
      console.debug("priceElement:", priceElement);
      
      if (priceElement) {
        // Text-Inhalt extrahieren und bereinigen
        const priceText = priceElement.textContent;
        console.debug("priceText:", priceText);
        
        // CHF entfernen und in Zahl konvertieren
        const price = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.'));
        console.debug("price:", price);
        
        if (price > 0) {
          event.preventDefault();
          alert('Produkte mit Preis werden von Ihrem Hausarzt leider nicht unterstüzt, das diese nicht von der Krankenkasse rückvergütet werden.');
          return false;
        }
      }
      return true;
    });
  } 
}

  
function preventSubmitIfNoDoc(cartForm) { //document.forms['{{ form_id }}']
  //var cartForm = document.querySelector('form[action="/cart/add"]'); // Adjust the selector to target your specific form
  if (cartForm) {
      cartForm.addEventListener('submit', function(event) {
          if (window.isProductAvailable == false ) {
              event.preventDefault(); // Prevents the form from submitting
              // Optional: display a message to the user
              alert("Im Demo-Shop können keine Produkte bestellt werden.");
          }
          
          //if (containsAnyWord(["ritalin","MEDIKINET","XANAX"])) {
        
          event.preventDefault(); // Prevents the form from submitting
          alert("Dies ist ein Demo-Shop - sprechen Sie mit Ihrem Hausarzt damit dieser für diese Platform aufgeschaltet wird. ")
      
      });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  console.debug(" check for removal of products with prices")
  // Funktion zum Entfernen von Produkten mit einem Preis
  function removePricedProducts() {
    document.querySelectorAll('.grid-product').forEach(product => {

      const priceElement = product.querySelector('.grid-product__price--current');
      if (priceElement && parseFloat(priceElement.textContent.replace(/[^\d.-]/g, '')) > 0) {
        product.remove();
      }
    });
  }

  // Entfernen von Produkten mit einem Preis beim Laden der Seite
  if (w_top_doc && w_top_doc.openshop==true ) {
    // nothing - do not filter
  } else {
    console.debug("wasa remove priced producs")
    removePricedProducts();
  }
  
});

// shows or hides line item notes

document.addEventListener("DOMContentLoaded", function () {
  console.debug("check for line item notes ")
    if (doctor) {
        //console.debug("doc: "+JSON.stringify(doctor));
        document.querySelectorAll(".wasanote").forEach(element => {
            if (doctor.line_notes) {
              //nothing
            } else {
                element.style.display = "none";
            }

      });
    }
});


